/**
 * Keys dos itens do menu permitidos no modo PWA mobile/tablet.
 * Para adicionar novos itens ao PWA, basta incluir o key correspondente neste array.
 */
export const PWA_ALLOWED_MENU_KEYS = ["customerService"];

/**
 * Keys dos subitens (collapse filhos) permitidos no modo PWA mobile/tablet.
 */
export const PWA_ALLOWED_SUBMENU_KEYS = ["chat"];

/**
 * Ids dos itens da navegação do Perfil permitidos no modo PWA.
 */
export const PWA_ALLOWED_PROFILE_NAV_IDS = ["profile", "change-password"];
